import { render, staticRenderFns } from "./PDPShipping.vue?vue&type=template&id=15bfb749&scoped=true"
import script from "./PDPShipping.vue?vue&type=script&lang=js"
export * from "./PDPShipping.vue?vue&type=script&lang=js"
import style0 from "./PDPShipping.vue?vue&type=style&index=0&id=15bfb749&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bfb749",
  null
  
)

export default component.exports